import { ReactComponent as PreviewIcon } from "@assets/svg/eye-filled.svg";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@components/ui/accordion";

import { TemplateHeaders } from "@constants/templates";

import { useTemplateById } from "@hooks/queries/use-templates";

import { Tooltip, TooltipContent, TooltipTrigger } from "../../ui/tooltip";

type TemplatePreviewProps = {
  templateId?: string;
};
export const TemplatePreview = ({ templateId }: TemplatePreviewProps) => {
  const {
    data: template,
    isLoading,
    isSuccess,
    error,
  } = useTemplateById(templateId, {
    enabled: !!templateId,
  });

  // Don't render anything if no template is selected
  if (!templateId) {
    return null;
  }

  if (error) {
    return <div className="text-sm text-destructive">Error loading template.</div>;
  }

  if (!isLoading && !template) {
    return <div className="text-muted-foreground text-sm">Template not found</div>;
  }

  const templateName = template?.name || "";
  const templateSections = (template?.sections ?? [])
    .slice()
    .sort(
      (a: { order?: number }, b: { order?: number }) =>
        (a.order ?? 0) - (b.order ?? 0)
    );

  return (
    <div className="rounded-xl bg-accent-50 p-3">
      <Accordion type="single" collapsible disabled={isLoading}>
        <AccordionItem value="item-1" defaultChecked>
          <AccordionTrigger className="py-2 text-sm text-foreground">
            {isLoading && "Loading template details"}

            {isSuccess && (
              <div className="flex items-center gap-2">
                <PreviewIcon className="size-4" /> Preview Selected Template
              </div>
            )}
          </AccordionTrigger>
          {isSuccess && (
            <AccordionContent className="max-h-40 space-y-2 overflow-y-auto border-t border-border py-2 text-sm">
              <p className="font-semibold text-foreground">{templateName}</p>
              <div className="text-muted-foreground mt-1">
                <ol className="list-decimal space-y-2 pl-8">
                  {templateSections.map((section: { id: string; name: string }) => (
                    <li key={section.id}>
                      <div className="flex items-center gap-2 text-wrap">
                        {section.name}
                      </div>
                    </li>
                  ))}
                </ol>
              </div>
            </AccordionContent>
          )}
        </AccordionItem>
      </Accordion>
    </div>
  );
};

const SectionInfoTooltip = ({ guide }: { guide: TemplateHeaders["guide"] }) => {
  if (!guide) return null;

  return null;
};
